import { useMemo } from 'react';
const formatNYAgo = (date) => {
    const now = new Date();
    const timestamp = new Date(date);
    const timeDiff = (now.getTime() - timestamp.getTime()) / 1000;
    const minutes = timeDiff / 60;
    if (minutes <= 60) {
        const roundedMinutes = Math.round(minutes);
        return `${Math.round(roundedMinutes)} ${roundedMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    const hours = minutes / 60;
    if (hours <= 24) {
        const roundedHours = Math.round(hours);
        return `${roundedHours} ${roundedHours === 1 ? 'hour' : 'hours'} ago`;
    }
    const roundedDays = Math.round(hours / 24);
    return `${roundedDays} ${roundedDays === 1 ? 'day' : 'days'} ago`;
};
const formatAsOfDate = (date) => {
    const formattedDate = new Date(date).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        minute: '2-digit',
        hour: '2-digit'
    });
    return `As of ${formattedDate}`;
};
const formatters = {
    'as-of': formatAsOfDate,
    'ny-ago': formatNYAgo
};
const useFormatter = (config) => {
    const { date, formatter } = config;
    const updatedAt = useMemo(() => {
        if (!date)
            return '';
        if (typeof formatter === 'function') {
            return formatter(date);
        }
        const formatterKey = formatter || 'as-of';
        const formatterFn = formatters[formatterKey];
        return formatterFn(date);
    }, [date, formatter]);
    return updatedAt;
};
export default useFormatter;
